export default {
  account: state => state.account,
  storage: state => state.storage,
  bucketContents: state => state.bucketContents,
  attached: state => state.attached,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy
}



// WEBPACK FOOTER //
// ./src/store/modules/storage/getters.js